import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IconX } from './Icons';

/**
 * Focused top bar for exercise pages (Quiz / Practice Lab).
 *
 * The full Academy nav is hidden in focus mode — the only way out is this
 * close button, which returns the user to the lesson (never the home page).
 * Keeps the user in flow during an exercise.
 */
const ExerciseTopBar = ({ kicker, title, closeTo }) => {
  const navigate = useNavigate();

  return (
    <div className="ac-exercise-bar">
      <div className="ac-exercise-bar-info">
        {kicker && <span className="ac-exercise-bar-kicker">{kicker}</span>}
        {title && <span className="ac-exercise-bar-title">{title}</span>}
      </div>
      <button
        type="button"
        className="ac-exercise-close"
        onClick={() => navigate(closeTo)}
        aria-label="Übung schließen"
        title="Übung schließen"
      >
        <IconX size={18} />
      </button>
    </div>
  );
};

export default ExerciseTopBar;
